import { userType } from '@/plugins/enums';
import { usersTenants } from '@/plugins/enums';

export default {
  menusDashboard: [
    {
      id: '1',
      icon: 'mdiViewDashboard',
      name: 'Dashboard',
      href: '/dashboard',
      permissions: {
        userType: [ userType.TYPE_SYSTEM, userType.TYPE_ADMIN, userType.TYPE_USER, userType.TYPE_SUPPORT, userType.TYPE_INSTRUCTOR ],
        tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_USER, usersTenants.TYPE_TECHNICIAN, usersTenants.TYPE_SUPERVISOR ],
      },
    },
    {
      id: '3',
      name: 'Ordens de serviço',
      icon: 'mdiBookOpen',
      href: '/service-orders',
      permissions: {
        userType: [ userType.TYPE_USER ],
        tenantUserType: [ usersTenants.TYPE_ADMIN, usersTenants.TYPE_TECHNICIAN, usersTenants.TYPE_SUPERVISOR],
        pra: true,
      },
    },
    {
      id: '6',
      name: 'Clientes',
      icon: 'mdiAccountMultiple',
      href: '/pra/parties',
      permissions: {
        userType: [ userType.TYPE_USER ],
        tenantUserType: [ usersTenants.TYPE_ADMIN ],
        pra: true,
      },
    },
    {
      id: '4',
      icon: 'mdiTextBox',
      name: 'Relatórios',
      href: '/pra/reports',
      permissions: {
        userType: [ userType.TYPE_USER ],
        tenantUserType: [ usersTenants.TYPE_ADMIN ],
        pra: true,
      },
    },
    {
      id: '5',
      icon: 'mdiNotebookEdit',
      name: 'Cadastros',
      href: '/pra/register',
      permissions: {
        userType: [ userType.TYPE_USER ],
        tenantUserType: [ usersTenants.TYPE_ADMIN ],
        pra: true,
      },
      children: [
        {
          id: '7',
          name: 'Colaboradores',
          href: '/pra/register/tenant/collaborators',
          permissions: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN ],
            pra: true,
          },
        },
        {
          id: '8',
          name: 'Supervisores',
          href: '/pra/register/supervisors',
          permissions: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN ],
            pra: true,
          },
        },
        {
          id: '9',
          name: 'Técnicos',
          href: '/pra/register/technicians',
          permissions: {
            userType: [ userType.TYPE_USER ],
            tenantUserType: [ usersTenants.TYPE_ADMIN ],
            pra: true,
          },
        },
      ],
    },
    {
      id: '10',
      icon: 'mdiFormatListCheckbox',
      name: 'Tarefas APR',
      href: '/pra/tasks',
      permissions: {
        userType: [ userType.TYPE_ADMIN ],
        pra: true,
      },
    },
  ],
};
